// https://c-ssl.duitang.com/upload/xxx.jpg -> upload/xxx.jpg
export const _removeHostOfImageUrl = (url: string) => {
  const regHost = /^https?/;
  const regPath = /^\//;
  if (regHost.test(url)) {
    return url.replace(/^https?:\/\/[^/]+\//, '');
  } else if (regPath.test(url)) {
    return url.replace(regPath, '');
  } else {
    return url;
  }
};
